import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsUp,
  faThumbsDown,
  faThumbsUp as faThumbsUpSolid,
  faThumbsDown as faThumbsDownSolid,
  faX,
  faCopy,
  faVolumeUp,
  faPause,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import { NegativeFeedbackOptions } from "../../constants/NegativeFeedbackOptions";
import { TypeFeedback } from "../../constants/TypeFeedback";
import { toast } from "react-toastify";

interface UnifiedProps {
  activeAudio: string | null;
  isPaused: { [key: string]: boolean };
  selectedRates: number;
  isSmallScreen: boolean;
  readMessage: (message: string, playbackRate: number, key: string) => void;
  pauseCurrentAudio: (key: string) => void;
  resumeCurrentAudio: (key: string) => void;
  adjustPlaybackRate: (rate: number, key: string) => void;
  msgAudioText: string;
  msg: any;
  handleFeedback: Function;
  feedbackGiven: any;
  showDownOptions: any;
  setShowDownOptions: Function;
  handleSubmitFeedback: Function;
  setShowFeedbackModal: Function;
}

const AudioFeedbackControls: React.FC<UnifiedProps> = ({
  activeAudio,
  isPaused,
  selectedRates,
  isSmallScreen,
  readMessage,
  pauseCurrentAudio,
  resumeCurrentAudio,
  adjustPlaybackRate,
  msgAudioText,
  msg,
  handleFeedback,
  feedbackGiven,
  showDownOptions,
  setShowDownOptions,
  handleSubmitFeedback,
  setShowFeedbackModal,
}) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(msg.response).then(() => {
      toast.success("Mensaje copiado al portapapeles", {
        position: "top-right",
        autoClose: 1500,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
        theme: "dark",
      });
    });
  };

  return (
    <div>
      {/* FEEDBACK + AUDIO BUTTONS */}
      <div className="feedback-buttons">
        {/* Botón de reproducción/pausa/parlante */}
        {activeAudio !== msgAudioText ? (
          <button
            className="feedback-button"
            onClick={() =>
              readMessage(msgAudioText, selectedRates, msgAudioText)
            }
          >
            <FontAwesomeIcon icon={faVolumeUp} />
          </button>
        ) : isPaused[msgAudioText] ? (
          <button
            className="feedback-button"
            onClick={() => resumeCurrentAudio(msgAudioText)}
          >
            <FontAwesomeIcon icon={faPlay} />
          </button>
        ) : (
          <button
            className="feedback-button"
            onClick={() => pauseCurrentAudio(msgAudioText)}
          >
            <FontAwesomeIcon icon={faPause} />
          </button>
        )}

        {/* Botón de copiar */}
        <button className="feedback-button" onClick={handleCopy}>
          <FontAwesomeIcon icon={faCopy} />
        </button>

        {/* Thumbs Up */}
        {feedbackGiven[msg.qa_id] === TypeFeedback["up"] ? (
          <button className="feedback-button-disabled">
            <FontAwesomeIcon icon={faThumbsUpSolid} />
          </button>
        ) : feedbackGiven[msg.qa_id] === TypeFeedback["down"] ? null : (
          <button
            className="feedback-button"
            onClick={() => handleFeedback(msg, TypeFeedback["up"])}
          >
            <FontAwesomeIcon icon={faThumbsUp} />
          </button>
        )}

        {/* Thumbs Down */}
        {feedbackGiven[msg.qa_id] === TypeFeedback["down"] ? (
          <button className="feedback-button-disabled">
            <FontAwesomeIcon icon={faThumbsDownSolid} />
          </button>
        ) : feedbackGiven[msg.qa_id] === TypeFeedback["up"] ? null : (
          <button
            className="feedback-button"
            onClick={() => handleFeedback(msg, TypeFeedback["down"])}
          >
            <FontAwesomeIcon icon={faThumbsDown} />
          </button>
        )}
      </div>

      {/* Selector de velocidad si está activo */}
      {activeAudio === msgAudioText &&
        (isSmallScreen ? (
          <select
            className="adjust-rate-select"
            onChange={(e) =>
              adjustPlaybackRate(parseFloat(e.target.value), msgAudioText)
            }
            value={selectedRates}
          >
            <option value={1.0}>1x</option>
            <option value={1.5}>1.5x</option>
            <option value={1.75}>1.75x</option>
            <option value={2.0}>2x</option>
          </select>
        ) : (
          <div className="feedback-buttons" style={{ marginTop: 8 }}>
            {[1.0, 1.5, 1.75, 2.0].map((rate) => (
              <button
                key={rate}
                className={`adjust-rate-button ${
                  selectedRates === rate ? "selected" : ""
                }`}
                onClick={() => adjustPlaybackRate(rate, msgAudioText)}
              >
                {rate}x
              </button>
            ))}
          </div>
        ))}

      {/* Feedback adicional */}
      {showDownOptions[msg.qa_id] && (
        <div className="feedback-down-container">
          <div className="feedback-down-header">
            <p>Cuéntanos más:</p>
            <button
              className="feedback-button-close"
              onClick={() =>
                setShowDownOptions((prev) => ({
                  ...prev,
                  [msg.qa_id]: false,
                }))
              }
            >
              <FontAwesomeIcon icon={faX} />
            </button>
          </div>
          <div className="feedback-down-options">
            {NegativeFeedbackOptions.map((elem, index) => (
              <button key={index} onClick={() => handleSubmitFeedback(elem)}>
                {elem}
              </button>
            ))}
            <button onClick={() => setShowFeedbackModal(true)}>Más...</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AudioFeedbackControls;
